
import store from '@/store'
import ApiClient from '@/common/api'

export default
  created: () ->
    api = new ApiClient()
    await api.get('/fc/login/logout')
    location.href = '/fcsystem'
